var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"main-container",attrs:{"id":"bid-equipment","fluid":"","tag":"section"}},[_c('idc-component-bid-equipments',_vm._b({attrs:{"settings":_vm.settings}},'idc-component-bid-equipments',{ ..._vm.$props },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }